import React from 'react';
import PropTypes from 'prop-types';
import Button from '../Button/Button';
import './DraftNotLoaded.pcss';
import Attention from '../../assets/Attention.svg';

const DraftNotLoaded = ({
  handleLoadDraft,
  handleDeleteDraft,
  loadDraftEmpty
}) => {
  const handleClick = () => {
    handleDeleteDraft();
    loadDraftEmpty();
  };

  return (
    <div className="DraftNotLoaded">
      <div className="DraftNotLoaded__icon">
        <Attention width={34} height={34} />
      </div>
      <div>
        <h2 className="DraftNotLoaded__title">Черновики не загружены</h2>
        <div className="DraftNotLoaded__description">
          <p className="DraftNotLoaded__description__text">
            Не удалось загрузить черновики. Если ранее вы заполняли заявление,
            повторите запрос позже или начните оформлять заявления заново.
          </p>
        </div>
        <Button
          primary
          onClick={handleLoadDraft}
          className="DraftNotLoaded__button"
        >
          Продолжить
        </Button>
        <Button
          primary
          onClick={handleClick}
          className="DraftNotLoaded__button"
        >
          Начать оформление заново
        </Button>
      </div>
    </div>
  );
};

DraftNotLoaded.propTypes = {
  handleLoadDraft: PropTypes.func,
  handleDeleteDraft: PropTypes.func,
  loadDraftEmpty: PropTypes.func
};

DraftNotLoaded.defaultProps = {
  handleLoadDraft: null,
  handleDeleteDraft: null,
  loadDraftEmpty: null
};

export default DraftNotLoaded;
